import {
    ColumnOptions,
    Filter,
    GetReportColumnsResponse,
    GetReportParams,
    GetReportResponse,
    GetReportRowsParams,
    GetReportRowsResponse,
    Pagination,
    ReportColumnOptionsRequest,
    ReportColumnOptionsResponse,
    ReportJobParams,
    ReportJobResponse,
    ReportJobStatusResponse,
    ReportRow,
} from '../common/interfaces/report';
import httpClient from './HttpClient';

interface ReportJobParamsDto {
    forceReload?: boolean;
    applyDefaultSort?: boolean;
    columnOptions?: ColumnOptions;
    contactColumnOptions?: ColumnOptions;
}

interface GetReportParamsDto {
    filter?: Filter;
    timestamp?: number;
    pagination: Pagination;
    jobId: string;
}

export const reportJob = async (params: ReportJobParams): Promise<ReportJobResponse> => {
    const { viewId, forceReload, applyDefaultSort, columnOptions, contactColumnOptions } = params;
    const response = await httpClient.post<ReportJobResponse, ReportJobParamsDto>(`/views/${viewId}/reports/reportjob`, {
        forceReload,
        applyDefaultSort,
        columnOptions,
        contactColumnOptions,
    });

    return response.data;
};

export const getReportJobStatus = async (viewId: string): Promise<ReportJobStatusResponse> => {
    const response = await httpClient.get<ReportJobStatusResponse>(`/views/${viewId}/reports/reportjobstatus`);

    return response.data;
};

export const getReport = async (params: GetReportParams): Promise<GetReportResponse> => {
    const { viewId, filter, timestamp, pagination, jobId } = params;
    const response = await httpClient.post<GetReportResponse, GetReportParamsDto>(`/views/${viewId}/reports/getreport`, {
        filter,
        timestamp,
        pagination,
        jobId,
    });

    return response.data;
};

export const getAllReportRows = async (viewId: string, reportJobId: string, limit: number): Promise<any> => {
    const allRows: ReportRow[] = [];
    let nextCursor: string | undefined;

    do {
        const response = await getReport({
            viewId,
            pagination: { limit, nextCursor },
            jobId: reportJobId,
        });

        const { rows, pagination } = response;
        allRows.push(...rows);
        nextCursor = pagination.nextCursor;
    } while (nextCursor);
    return allRows;
};

export const getColumns = async (viewId: string): Promise<GetReportColumnsResponse> => {
    const url = `/views/${viewId}/reports/columns`;
    const response = await httpClient.get<GetReportColumnsResponse>(url);

    return response.data;
};

export const getReportRows = async (params: GetReportRowsParams): Promise<GetReportRowsResponse> => {
    const { viewId, sheetId, rowIds } = params;

    const response = await httpClient.post<
        GetReportRowsResponse,
        {
            rowIds: number[];
        }
    >(`/views/${viewId}/reports/grid/${sheetId}/getrows`, {
        rowIds,
    });

    return response.data;
};

export const getReportColumnOptions = async (viewId: string, params: ReportColumnOptionsRequest): Promise<ReportColumnOptionsResponse> => {
    const url = `/views/${viewId}/reports/columnoptions`;
    const response = await httpClient.post<ReportColumnOptionsResponse, ReportColumnOptionsRequest>(url, params);

    return response.data;
};
